import type { TransactionListResponse } from '@pet/shared';
import { ReceiptApiError } from './receiptClient';

// Re-export so read screens can catch a single error type without reaching into
// receiptClient, matching paymentReadClient.ts.
export { ReceiptApiError };

async function extractErrorMessage(res: Response): Promise<string> {
  try {
    const body = (await res.json()) as { error?: string };
    return body.error ?? `HTTP ${res.status}`;
  } catch {
    return `HTTP ${res.status}`;
  }
}

// GET /api/transactions — the expense ledger read directly (AD-17), including rows
// that belong to no payment. Returns both keys of the envelope: the capped list and
// the per-property totals computed server-side over the whole ledger.
export async function getTransactions(): Promise<TransactionListResponse> {
  const res = await fetch('/api/transactions', { credentials: 'include' });
  if (!res.ok) {
    throw new ReceiptApiError(res.status, await extractErrorMessage(res));
  }
  const data = (await res.json()) as TransactionListResponse;
  return { transactions: data.transactions, propertyTotals: data.propertyTotals };
}
